import AbstractAnalytics from '../services/abstract-analytics';
import Analytics from '../services/analytics';
import useMock from './useMock';

export default function useAnalytics() : AbstractAnalytics {
    const configuration = useMock();
    return Analytics.getInstance(configuration);
}
